import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import 'dayjs/locale/en';

// Extend dayjs with plugins
dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(localizedFormat);

// Configure dayjs globally
dayjs.locale('en'); // Set default locale

export const formatDate = (date) => dayjs(date).format('MMMM D, YYYY');

export const formatDateTime = (date) =>
  dayjs(date).format('MMMM D, YYYY h:mm A');

export const formatTimeAgo = (date) => dayjs(date).fromNow();

export const formatShortDate = (date) => dayjs(date).format('MM/DD/YYYY');

export const formatLongDate = (date) => dayjs(date).format('LL');
export const formatLongDateTime = (date) => dayjs(date).format('LLLL');
export const expireDate = (days) =>
  dayjs().utc().add(days, 'days').toDate().toISOString();
// Special function for Firebase Timestamps
export const formatFirebaseDate = (timestamp) => {
  if (!timestamp?.toDate) return '';
  return dayjs(timestamp.toDate()).format('L'); // Localized short date (MM/DD/YYYY)
};

// Add any other date formatting functions you need

export default dayjs;
